import { render, staticRenderFns } from "./HelpMobile.vue?vue&type=template&id=ed13005a&scoped=true"
import script from "./HelpMobile.vue?vue&type=script&lang=js"
export * from "./HelpMobile.vue?vue&type=script&lang=js"
import style0 from "./HelpMobile.vue?vue&type=style&index=0&id=ed13005a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed13005a",
  null
  
)

export default component.exports